<footer>
    <p>
        {{strTextoFooter}}
    </p>
  </footer>
